import { useState, useEffect } from "react";
import { Card } from "./Card";
import { Country } from "./CountrySelector";
import Heatmap from "./HeatMap";
import { API_URL } from "../config/env";

export interface RiskDataPoint {
  date: string;
  longitude: number;
  latitude: number;
  weight: number;
}

interface HistoricalRiskMapProps {
  country: Country;
}

export function HistoricalRiskMapCard({ country }: HistoricalRiskMapProps) {
  const [data, setData] = useState<RiskDataPoint[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  // Fetch heatmap data from API on mount
  const fetchHeatmapData = async () => {
    setIsLoading(true);
    setHasError(false);
    try {
      const response = await fetch(`${API_URL}/map`);
      if (response.ok) {
        const data = await response.json();
        setData(data);
      } else {
        throw new Error(`API request failed with status ${response.status}.`);
      }
    } catch (error) {
      console.error("Failed to fetch heatmap data from API:", error);
      setData([]);
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHeatmapData();
  }, []);

  return (
    <Card>
      <h2 className="text-xl font-semibold mb-4">Historical Risk Map</h2>
      <div className="flex-1 min-h-0">
        <Heatmap
          data={data}
          iso={country.iso}
          initialView={country.coordinates ?? undefined}
          isLoading={isLoading}
          hasError={hasError}
        />
      </div>
    </Card>
  );
}
